(function () {
  'use strict';

  function qs(selector, context) {
    return (context || document).querySelector(selector);
  }

  function qsa(selector, context) {
    return Array.from((context || document).querySelectorAll(selector));
  }

  function trapFocus(container) {
    var focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
    first.focus();
  }

  function initMobileMenu() {
    var toggle = qs('[data-mobile-menu-toggle]');
    var menu = qs('[data-mobile-menu]');
    if (!toggle || !menu) return;

    var closeBtn = qs('[data-mobile-menu-close]', menu);
    var overlay = qs('[data-mobile-menu-overlay]', menu);

    function openMenu() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      trapFocus(menu);
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      toggle.focus();
    }

    toggle.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });
  }

  function initSearchModal() {
    var openBtns = qsa('[data-search-toggle]');
    var modal = qs('[data-search-modal]');
    if (!modal) return;

    var closeBtn = qs('[data-search-close]', modal);
    var overlay = qs('[data-search-overlay]', modal);
    var input = qs('[data-search-input]', modal);

    function openSearch() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (input) {
        input.focus();
      }
    }

    function closeSearch() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    if (overlay) overlay.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeSearch();
    });
  }

  function initCartDrawer() {
    var drawer = qs('[data-cart-drawer]');
    if (!drawer) return;

    var overlay = qs('[data-cart-drawer-overlay]', drawer);
    var closeBtn = qs('[data-cart-drawer-close]', drawer);

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      trapFocus(drawer);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    qsa('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    window.openCartDrawer = openDrawer;
  }

  function initCollectionFilters() {
    var toggle = qs('[data-filters-toggle]');
    var filters = qs('[data-collection-filters]');
    if (!toggle || !filters) return;

    toggle.addEventListener('click', function () {
      filters.classList.toggle('is-open');
      var expanded = filters.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', expanded);
    });
  }

  function initProductGallery() {
    var gallery = qs('[data-product-gallery]');
    var mainImage = qs('[data-product-main-image]', gallery || document);
    var thumbs = qsa('[data-product-thumb]', gallery || document);
    var prevBtn = qs('[data-gallery-prev]', gallery || document);
    var nextBtn = qs('[data-gallery-next]', gallery || document);
    if (!mainImage || !thumbs.length) return;

    var currentIndex = Math.max(0, thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-active');
    }));
    var cache = {};

    thumbs.forEach(function (thumb, index) {
      thumb.setAttribute('data-index', index);
      var src = thumb.getAttribute('data-full-src');
      if (src && !cache[src]) {
        cache[src] = new Image();
        cache[src].src = src;
      }
    });

    function markActive(index) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      if (thumbs[index]) thumbs[index].classList.add('is-active');
    }

    function setMainImage(index) {
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      var thumb = thumbs[index];
      if (!thumb) return;

      var src = thumb.getAttribute('data-full-src');
      var alt = thumb.getAttribute('data-alt') || '';
      if (!src) return;

      currentIndex = index;
      markActive(index);
      thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });

      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.setAttribute('alt', alt);

      if (mainImage.getAttribute('src') === src) return;

      mainImage.classList.add('is-changing');
      var preloaded = cache[src];
      var applyImage = function () {
        mainImage.setAttribute('src', src);
        window.requestAnimationFrame(function () {
          mainImage.classList.remove('is-changing');
        });
      };

      if (preloaded && preloaded.complete) {
        applyImage();
      } else {
        if (!preloaded) {
          preloaded = new Image();
          cache[src] = preloaded;
        }
        preloaded.onload = applyImage;
        preloaded.src = src;
      }
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        setMainImage(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        setMainImage(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        setMainImage(currentIndex + 1);
      });
    }
  }

  function initProductAccordions() {
    qsa('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var accordion = trigger.closest('[data-accordion]');
        if (!accordion) return;
        var isOpen = accordion.classList.contains('is-open');
        qsa('[data-accordion]', accordion.parentElement).forEach(function (item) {
          item.classList.remove('is-open');
          var btn = qs('[data-accordion-trigger]', item);
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          accordion.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initProductForm() {
    var form = qs('[data-product-form]');
    if (!form) return;

    var buyNowBtn = qs('[data-buy-now]', form);
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        if (form.dataset.cartType === 'drawer') {
          var formData = new FormData(form);
          buyNowBtn.disabled = true;
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Add to cart failed');
              window.location.href = window.Shopify.routes.root + 'checkout';
            })
            .catch(function () {
              form.submit();
            })
            .finally(function () {
              buyNowBtn.disabled = false;
            });
        } else {
          var checkoutInput = qs('input[name="return_to"]', form);
          if (!checkoutInput) {
            checkoutInput = document.createElement('input');
            checkoutInput.type = 'hidden';
            checkoutInput.name = 'return_to';
            form.appendChild(checkoutInput);
          }
          checkoutInput.value = '/checkout';
          form.submit();
        }
      });
    }
  }

  function initAjaxCart() {
    var form = qs('[data-product-form]');
    if (!form || !window.openCartDrawer) return;

    form.addEventListener('submit', function (e) {
      if (form.dataset.cartType !== 'drawer') return;

      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = qs('[type="submit"]', form);
      if (submitBtn) submitBtn.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          return fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
        })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newDrawer = doc.querySelector('[data-cart-drawer]');
          var currentDrawer = qs('[data-cart-drawer]');
          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
            initCartDrawer();
            initCartRemove();
          }
          updateCartCount();
          window.openCartDrawer();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  function initCartRemove() {
    qsa('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var key = btn.getAttribute('data-cart-remove');
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function () {
            return fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
          })
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newDrawer = doc.querySelector('[data-cart-drawer]');
            var currentDrawer = qs('[data-cart-drawer]');
            if (newDrawer && currentDrawer) {
              currentDrawer.innerHTML = newDrawer.innerHTML;
              initCartDrawer();
              initCartRemove();
            }
            updateCartCount();
          });
      });
    });
  }

  function updateCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }


  function initNavActiveState() {
    var links = qsa('[data-nav-link]');
    if (!links.length) return;

    var currentPath = window.location.pathname.replace(/\/$/, '') || '/';

    links.forEach(function (link) {
      link.classList.remove('is-active');
      link.removeAttribute('aria-current');

      var href = link.getAttribute('href');
      if (!href) return;

      var linkUrl;
      try {
        linkUrl = new URL(href, window.location.origin);
      } catch (e) {
        return;
      }

      var linkPath = linkUrl.pathname.replace(/\/$/, '') || '/';
      var isExact = linkPath === currentPath;

      if (isExact) {
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'page');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNavActiveState();
    initMobileMenu();
    initSearchModal();
    initCartDrawer();
    initCollectionFilters();
    initProductGallery();
    initProductAccordions();
    initProductForm();
    initAjaxCart();
    initCartRemove();
  });
})();
